import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';
import DateSelectorV2 from '../FormInputs/DateSelectorV2/DateSelectorV2';
import TextArea from '../FormInputs/TextArea/TextArea';
import TextInput from '../FormInputs/TextInput/TextInput';
import Number from '../FormInputs/Number/Number';
import Multiselect from '../FormInputs/Multiselect/Multiselect';
import CustomSelect from '../FormInputs/CustomSelect/CustomSelect';

const CustomFieldContent = ({
  field,
  getIconClass,
  handleEditClick,
  setSelectedDate,
  numberValue,
  setNumberValue,
}) => (
  <div className="flex flex-row mt-3 mb-3" data-testid="custom-fields-content">
    <div className="w-[182px] flex flex-row items-start">
      {field.type === 'FormItem::Heading' ? (
        <div className="flex flex-row item-center mb-6.5 py-3">
          <div className="flex">
            <Icon name="drag_indicator" className="w-2 h-3 text-vamos-gray mr-2.5 mt-1.5 ml-2" />
            <p className="text-base font-bold text-vamos-black flex items-center">
              {field.label}
            </p>
          </div>
          <button
            type="button"
            className="cursor-pointer flex items-center justify-center h-full"
            onClick={() => handleEditClick(field)}
            data-testid="edit-custom-field-button-heading"
          >
            <Icon name="edit_customFields" className={getIconClass(field.type)} />
          </button>
          <div title="Inactive field" className="flex items-center justify-center ml-3 mb-1 w-6">
            {!field.active ? (
              <Icon name="hide_password" />
            ) : null}
          </div>
        </div>
      ) : (
        <div className="flex flex-row">
          <Icon name="drag_indicator" className="w-1.875 h-3 text-vamos-gray mr-2.5 mt-1.5 ml-2" />
          <p className="text-base flex items-center">
            <span className="relative" data-testid="custom-field-label">
              {field.label}
              {field.required && (
                <Icon
                  name="required_field"
                  className="absolute top-[3px] right-[-10px] w-2 h-2"
                />
              )}
            </span>
          </p>
        </div>
      )}
    </div>

    <div className="w-[352px] ml-5">
      {field.type === 'FormItem::Select' && (
        <div className="mb-6.5">
          <CustomSelect
            placeholder="select"
            options={field.options?.map(option => ({ label: option, value: option })) || []}
            value={field.value?.find(item => item.selected)?.value || ''}
            inputHeight="h-10"
          />
        </div>
      )}

      {field.type === 'FormItem::Text' && (
        <div>
          <TextArea
            name="customTextArea"
            placeholder="enter text"
            className="!mt-0 !mb-6.5 !px-3 !py-1.5 !space-y-0 block"
          />
        </div>
      )}

      {field.type === 'FormItem::Date' && (
        <div className="relative mb-6.5 h-10">
          <DateSelectorV2
            name="customDate"
            className="!w-88.5 !h-10 !py-1.5 !px-3 appearance-none bg-none"
            dateIconStyles={{
              position: 'absolute',
              top: '50%',
              right: 3,
              transform: 'translateY(-50%)',
              color: 'black',
            }}
            placeholder="select a date"
            disabled
            value={null}
            setValue={setSelectedDate}
          />
        </div>
      )}

      {field.type === 'FormItem::Line' && (
        <div>
          <TextInput
            name="customText"
            placeholder="enter short text"
            className="mb-6.5 !text-vamos-gray !h-10"
          />
        </div>
      )}

      {field.type === 'FormItem::Number' && (
        <div>
          <Number
            name={`number-field-${field.id}`}
            placeholder="enter number"
            inputHeight="h-10"
            className="mb-6.5"
            value={numberValue[field.id] || ''}
            setValue={(newValue) => setNumberValue(prev => ({ ...prev, [field.id]: newValue || '' }))}
          />
        </div>
      )}

      {field.type === 'FormItem::Multiselect' && (
        <div className="mb-6.5">
          <Multiselect
            options={field.options?.map(option => ({ label: option, value: option })) || []}
            value={
              field.value?.filter(item => item.selected).map(item => ({
                label: item.label,
                value: item.value,
              })) || []
            }
            inputHeight="h-10"
          />
        </div>
      )}
    </div>

    <div>
      {field.type !== 'FormItem::Heading' && (
      <div className="flex flex-row items-center justify-center h-full">
        <button
          type="button"
          className="cursor-pointer pb-7 mr-3"
          onClick={() => handleEditClick(field)}
          data-testid="edit-custom-field-button"
        >
          <Icon name="edit_customFields" className={getIconClass(field.type)} />
        </button>
        <div title="Encrypted field" className="flex items-center justify-center pb-7 mr-2 w-6">
          {field.encrypt ? (
            <Icon name="encrypted" />
          ) : null}
        </div>
        <div title="Inactive field" className="flex items-center justify-center pb-7 w-6">
          {!field.active ? (
            <Icon name="hide_password" />
          ) : null}
        </div>
      </div>
      )}
    </div>
  </div>
);

CustomFieldContent.propTypes = {
  field: PropTypes.object.isRequired,
  getIconClass: PropTypes.func.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  numberValue: PropTypes.object.isRequired,
  setNumberValue: PropTypes.func.isRequired,
};

export default CustomFieldContent;
